module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-kanto-1-32fb85080032c892a611f624e243029e.png";